import { Provider as ReduxProvider } from 'react-redux'
import { store } from 'store'
import {ConfirmProvider} from "popup/ConfirmContext";
import {Toaster} from 'react-hot-toast';

export function Providers({ children, session }: { children: React.ReactNode, session: any }) {
    return (
        <ReduxProvider store={store}>
            <ConfirmProvider>
                <Toaster
                    position="bottom-right"
                    gutter={8}
                    toastOptions={{
                        // Default options for specific types
                        success: {
                            duration: 3000,
                            style: {
                                background: '#4BB543',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                fontSize: '16px',
                                maxWidth: '500px',
                                padding: '12px 16px',
                            },
                            iconTheme: {
                                primary: '#fff',
                                secondary: '#4BB543',
                            },
                        },
                        error: {
                            duration: 4000,
                            style: {
                                background: '#FF3333',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                fontSize: '16px',
                                maxWidth: '500px',
                                padding: '12px 16px',
                            },
                            iconTheme: {
                                primary: '#fff',
                                secondary: '#4BB543',
                            },
                        },
                        style: {
                            background: '#fff',
                            color: '#333',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            borderRadius: '8px',
                            fontSize: '16px',
                            maxWidth: '500px',
                            padding: '12px 16px',
                        },
                    }}
                />
                {children}
            </ConfirmProvider>
        </ReduxProvider>
    )
}
